import memoizeOne from 'memoize-one'
import { ascend, prop, sortWith } from 'ramda'

export const roomOptionSort = sortWith([
  ascend(prop('archived')),
  ascend(prop('sequence')),
  ascend(prop('name')),
])

/**
 * Get room options for the room chooser, given a entity slice for rooms and an optional filter
 * it returns a list of options for the room chooser.
 * @param {Object<id, roomEntity>} rooms - entity slice for rooms
 * @param {string|string[]|function} filterBy - optional filter for rooms
 */
export const getRoomOptions = memoizeOne((rooms, filterBy) => {
  let list = Object.values(rooms).sort(roomOptionSort)

  if (filterBy) {
    if (typeof filterBy === 'function') {
      list = list.filter(filterBy)
    } else if (Array.isArray(filterBy)) {
      list = list.filter(r => filterBy.some(filter => r[filter]))
    } else {
      list = list.filter(r => r[filterBy])
    }
  }

  return list.map(({ id: value, name: label }) => ({ label, value }))
})

export const getZoneOptions = memoizeOne((zones, room) => (
  Object.values(zones)
    .filter(({ room: zoneRoom }) => zoneRoom === room)
    .map(({ id: value, name: label }) => ({ label, value }))
))
